export default __webpack_public_path__ + "static/media/wn_7_3.c37b09d2.webp";